import { useThreeDStudioStore } from 'Pods/ThreeDStudio/Store'
import { STUDIO_ACCESS_TIER } from 'Pods/ThreeDStudio/Store/constants'

const DCC_BRIDGE_TIERS = new Set([
  STUDIO_ACCESS_TIER.SUBSCRIBED,
  STUDIO_ACCESS_TIER.HAS_CREDITS,
])

function useDccBridgeAccess() {
  const studioAccessTier = useThreeDStudioStore((state) => state.subscription.studioAccessTier)
  return DCC_BRIDGE_TIERS.has(studioAccessTier)
}

export default useDccBridgeAccess
